import React from 'react';

// multiple-rows
export const constructNavColumnWithHeading = (data: any) => {
    return (
        <div className="nav-bar-component__nav-column-with-heading" key={data.id}>
            <div className="heading">
                { data.name }
            </div>
            <ul className="flex-column" key={data.id}>
                {
                    data.children.map(x => {
                        return (
                            <li className="flex-item" key={x.id}>
                                <a className='nav-link' href={x.href} key={x.id}>
                                    { x.name }
                                </a>
                            </li>
                        );
                    })
                }
            </ul>
        </div>
    );
};

// multiple-rows
export const constructNavMultipleColumnsWithHeading = (data: any) => {
    return (
        <div className="content navbar-component_row">
            <div className="nav-bar-component__multiple-rows">
                {
                    data.children.map(x => constructNavColumnWithHeading(x))
                }
            </div>
        </div>
    );
};


// prefix-button-with-icon
export const constructPrefixNavButtonsWithIcon = (data: any) => {
    return data.children
        .filter(x => x.style && x.style === 'prefix-button-with-icon')
        .map(x => {
            return x.children.map(y => {
                return (
                    <a className="navbar-component_prefix-button-with-icon" key={y.id} href={y.href} style={{backgroundImage: `url(${y.imgsrc})`}}>
                        { y.name }
                    </a>
                )
            })
        });
};

export const constructGallery = (data: any) => {
    return (
        data.children
            .filter(x => x.style && x.style === 'gallery')
            .map(x => (
                <div className="navbar-component_gallery" key={x.id}>
                    <div className="navbar-component_gallery-heading">
                        {x.name}
                    </div>
                    <ul className="navbar-component_gallery-list">
                        {
                            x.children.map(y => {
                                return (
                                    <li className="navbar-component_gallery-post" key={y.id}>
                                        <a className="navbar-component_gallery-post-content" href={y.href}>
                                            <div className="navbar-component_gallery-post-content-thumbnail">
                                                <img src={y.imgsrc} alt={y.name} className="navbar-component_gallery-post-content-thumbnail"></img>
                                            </div>
                                            <div className="navbar-component_gallery-post-content-description">
                                                { y.name }
                                            </div>
                                        </a>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            )
        )
    );
};
